function feedback(state = { items: [] }, action) {
  switch (action.type) {
    case 'RECEIVE_FEEDBACK':
      return {
        ...state,
        items: action.feedback,
      };
    default:
      return state;
  }
}
export default feedback;
